/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StorefrontInputs */

const en_nav_storefront = /** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const id_nav_storefront = /** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toko`)
};

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const es_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const fr_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const de_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const ja_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const zh_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const ar_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const it_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const ru_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const pt_nav_storefront = en_nav_storefront;

/** @type {(inputs: Nav_StorefrontInputs) => LocalizedString} */
const ko_nav_storefront = en_nav_storefront;

/**
* | output |
* | --- |
* | "Store" |
*
* @param {Nav_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_storefront = /** @type {((inputs?: Nav_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_storefront(inputs)
	if (locale === "es") return es_nav_storefront(inputs)
	if (locale === "fr") return fr_nav_storefront(inputs)
	if (locale === "de") return de_nav_storefront(inputs)
	if (locale === "ja") return ja_nav_storefront(inputs)
	if (locale === "zh") return zh_nav_storefront(inputs)
	if (locale === "ar") return ar_nav_storefront(inputs)
	if (locale === "id") return id_nav_storefront(inputs)
	if (locale === "it") return it_nav_storefront(inputs)
	if (locale === "ru") return ru_nav_storefront(inputs)
	if (locale === "pt") return pt_nav_storefront(inputs)
	return ko_nav_storefront(inputs)
});